import { FC, ReactElement } from 'react'
import styled, { keyframes } from 'styled-components'
import { device } from '../breakpoints'
import { FortuneArrow } from './FortuneArrow'
import { MainSectorsIcons } from './MainSectorsIcons'
import { InlineFortuneChart } from 'components/InlineFortuneChart'
import { BsArrowRight } from 'react-icons/bs'

interface ListItemProps {
  data: Person
}

const ListItem: FC<ListItemProps> = ({ data }): ReactElement => {
  const isMobile = window.innerWidth < 768

  return (
    <Container
      target='_blank'
      href={`https://www.bilan.ch/${data.unityMetadataId || 0}`}
      isNew={data.fortuneEvolution === 'new'}
    >
      <Content>
        <RowContainer>
          <RankContainer>
            <Rank>{data.rank}</Rank>
          </RankContainer>

          <RowContent>
            <NameContainer>
              {/* <IconContainer>
                <MainSectorsIcons icon={data.mainSector} />
              </IconContainer> */}
              <div>
                <Title>{data.name}</Title>
                <BusinessName>{data.businessName}</BusinessName>
              </div>
            </NameContainer>

            <Foreground>
              {/* {!isMobile ? <div>
                <div>
                  <span style={{ opacity: 0.45 }}>Secteur d'activité:</span>{' '}
                  {data.mainSector === 'Top 10'
                    ? data.sectors[0]
                    : data.mainSector}
                </div>
                <span style={{ opacity: 0.45 }}>Résidence principale:</span>{' '}
                {data.residence.join(', ')}
              </div> : <div>
              {data.residence.join(', ')} •{' '} 
              {data.mainSector === 'Top 10'
                    ? data.sectors[0]
                    : data.mainSector}
                </div>} */}
              <div>
                <Info>
                  {/* <span style={{ opacity: 0.45 }}>{isMobile ? 'Secteur:' : "Secteur"}</span>{' '} */}
                  <IconContainer>
                    <MainSectorsIcons icon={data.mainSector} />
                  </IconContainer>
                  <div>
                    <Strong>
                      {data.mainSector === 'Top 10'
                        ? data.sectors[0]
                        : data.mainSector === 'Horlogerie'
                        ? 'Luxe et horlogerie'
                        : data.mainSector}
                    </Strong>
                    , {data.residence.join(', ')}
                  </div>
                </Info>
                {/* <span style={{ opacity: 0.45 }}>{isMobile ? "Résidence:" : "Résidence"}</span>{' '} */}
              </div>
            </Foreground>

            <FortuneContainer>
              <FortuneContent>
                <FortuneArrow
                  inverted
                  fortuneEvolution={data.fortuneEvolution}
                />
                {data.formattedFortune}{' '}
                {data.fortuneEvolution !== 'new' ? (
                  <MiniChartContainer>
                    <InlineFortuneChart rawData={data.fortunes} />
                  </MiniChartContainer>
                ) : (
                  <NewLabel>
                    <NewLabelContent>Nouveau</NewLabelContent>
                  </NewLabel>
                )}
              </FortuneContent>
            </FortuneContainer>
          </RowContent>

          <LinkArrowContainer>
            <BsArrowRight />
          </LinkArrowContainer>
          <IconMobileContainer>
            <MainSectorsIcons icon={data.mainSector} />
          </IconMobileContainer>
        </RowContainer>
      </Content>
    </Container>
  )
}

const IconContainer = styled.div`
  display: inline-block;
  transform: translate(5px, 3px);
  margin-right: 20px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
      display: none;
  }

  @media ${device.tablet}, @media ${device.laptop} {
      display: block;
`

const IconMobileContainer = styled.div`
  display: inline-block;
  transform: translate(5px, 3px);
  margin-right: 20px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
      display: block;
  }

  @media ${device.tablet}, @media ${device.laptop} {
      display: none;
`

const NameContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: 1fr;
    ${IconContainer} {
      display: none;
    }
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: 1fr;
    ${IconContainer} {
      display: block;
    }
  }
`

const Info = styled.div`
  display: flex;
  align-items: center;
`

const RowContent = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 0.75fr 1.2fr;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: 1fr;
    grid-gap: 6px;
    max-width: none;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: 1fr 0.75fr 1.2fr;
    grid-gap: 20px;
    max-width: 65vw;
  }
`

const Strong = styled.strong`
  font-smoothing: antialiased;
  font-weight: 600;
`

const LinkArrowContainer = styled.div`
  text-align: right;
  padding-right: 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  display: none;
`

const RowContainer = styled.div`
  line-height: 1.4;
  display: grid;
  grid-template-columns: 30px 1fr;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: 30px 1fr 50px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: 30px 1fr;
  }
`

const BusinessName = styled.div`
  margin-top: 0.25em;
`

const FortuneContainer = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  text-align: right;
  font-family: var(--font-sans-serif);
  white-space: nowrap;
  color: ${({ theme }) => theme.colorMain};

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 0;
    font-size: 1em;
    text-align: left;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0 0 0 20px;
    font-size: 1.2em;
    text-align: right;
  }
`

const FortuneContent = styled.div`
  position: relative;
  display: inline-block;
  // padding: 10px 20px;
  // background-color: ${({ theme }) => theme.colorMainLight};
  // border-radius: 16px;
`

const RankContainer = styled.div`
  transform: translateY(3px);
  text-align: right;
  padding-right: 20px;
`

const Rank = styled.div`
  border-radius: 16px;
  font-family: var(--font-sans-serif);
  font-size: 0.85em;
  font-weight: bold;
`

const MiniChartContainer = styled.div`
  width: 50px;
  display: inline-block;
  transform: translateY(25%);
`

const Foreground = styled.div`
  position: relative;
  display: grid;
  line-height: 1.2;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: 1fr 50px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: 1fr;
  }
`

const Title = styled.div`
  font-size: 1.25em;
  line-height: 1.2;
  transition: color 0.2s ease-in-out;
  display: inline-block;
  font-family: var(--font-serif);
  font-weight: bold;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.75em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1.25em;
  }
`

const NewLabel = styled.div`
  width: 50px;
  text-align: center;
  display: inline-block;
`

const fadeIn = keyframes`
  0% {
    transform: translateX(10px);
  }

  50% {
    transform: translateX(0px);
  }

  100% {
    transform: translateX(10px);
  }
`

const NewLabelContent = styled.div`
  display: inline-block;
  background-color: ${({ theme }) => theme.colorMain};
  line-height: 1;
  border-radius: 10px;
  padding: 5px 6px 4px 6px;
  color: ${({ theme }) => theme.textColorInverted};
  font-size: 0.35em;
  position: relative;
  text-transform: uppercase;
  font-family: var(--font-sans-serif);
  transform: translateY(-20%);
  font-weight: 900;
`

const Content = styled.div`
  margin: 0px;
`

const Container = styled.a<{ isNew: boolean }>`
  font-family: var(--font-sans-serif);
  font-size: 1rem;
  cursor: pointer;
  position: relative;
  min-width: 0;
  -webkit-font-smoothing: antialiased;
  display: block;
  text-decoration: none;
  transition: color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  border-top: ${({ theme }) => `1px solid ${theme.grayColor}`};
  color: ${({ theme }) => theme.textColor};

  background-color: ${({ isNew, theme }) =>
    isNew ? `${theme.grayColor}66` : 'transparent'};

  &:hover {
    border-top: 1px solid ${({ theme }) => theme.colorMain};
  }

  &:hover ${RowContainer} {
    color: ${({ theme }) => theme.colorMain};
  }

  &:hover ${LinkArrowContainer} {
    animation: ${fadeIn} 1s ease-in infinite;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 15px 0;
    padding-bottom: 30px;
    font-size: 0.85em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 12px 0 12px 0;
    font-size: 0.85em;
  }
`

export default ListItem
